import {
    GET_AVAILABlE_UNIT,
    FILTER_TOWER,
    FILTER_FLOOR,
    CHOOSED_UNIT
} from '../actions/types'


const INITIAL_STATE = {
    units: [],
    tower: [],
    floor: [],
    chooseTower: 'Select Tower',
    chooseFloor: 'Select Floor',
    choosedUnit: {
        tower: '',
        floor: 0,
        room_number: '',
        deposit:'',
        price_sqft:"",
        total_price: 0
    }

}
export default (state = INITIAL_STATE, action ) => {

    // console.log("------- Choose Unit Reducer --------")
    // console.log(action.payload)

    switch (action.type) {

        case GET_AVAILABlE_UNIT:
            return { ...state, units: action.payload }
        
        case FILTER_TOWER:
            return { ...state, chooseTower: action.payload }
        
        case FILTER_FLOOR:
            return { ...state, chooseFloor: action.payload }
        
        case CHOOSED_UNIT:
            return { ...state, choosedUnit: {
                ...state.choosedUnit.tower, tower: action.payload.tower,
                ...state.choosedUnit.floor, floor: action.payload.floor,
                ...state.choosedUnit.room_number, room_number: action.payload.room_number,
                ...state.choosedUnit.deposit, deposit: action.payload.deposit,
                ...state.choosedUnit.price_sqft, price_sqft: action.payload.price_sqft,
                ...state.choosedUnit.total_price, total_price: action.payload.price_sqft
            }}
            
        default:
            return state
    }

}